import { useQuery } from '@tanstack/react-query';
import type { TaskAssigneesDTO, TaskDTO, TaskNoteDTO } from '@prism/contracts';
import { api } from '../client';
import { queryKeys } from '../queryKeys';
import { usePaged } from './paged';

interface TaskQuery { scope?: 'mine' | 'created' | 'all'; assigned?: 'me' | 'shared' | 'any'; status?: 'active' | 'done' | 'all'; assetId?: string; sequenceId?: string; collectionId?: string }
export function useTasks(query: TaskQuery, enabled = true) {
  const params = new URLSearchParams(Object.entries(query).filter(([, v]) => v) as Array<[string, string]>);
  return usePaged<TaskDTO>({ queryKey: queryKeys.tasks(params.toString()), url: `/api/v1/tasks?${params}`, enabled, refetchInterval: 15_000 });
}
export function useTaskSummary() {
  return useQuery({ queryKey: queryKeys.taskSummary(), queryFn: () => api<{ open: number; overdue: number; approvals: number; unseen: number }>('/api/v1/tasks/summary'), refetchInterval: 30_000 });
}
export function useAssignees() {
  return useQuery({ queryKey: queryKeys.taskAssignees(), queryFn: () => api<TaskAssigneesDTO>('/api/v1/tasks/assignees'), staleTime: 60_000 });
}
export function useTaskNotes(id: string | null) {
  return useQuery({ queryKey: queryKeys.taskNotes(id), queryFn: () => api<{ items: TaskNoteDTO[] }>(`/api/v1/tasks/${id}/notes`), enabled: Boolean(id) });
}
